module.exports = __webpack_public_path__ + "static/media/confirmed.7c31e3ab.svg";